import { AUTH_TYPES, TEMPLATE_CATEGORIES } from './constants.js'

export const onesignalTemplate = {
	id: 'onesignal',
	guid: '89062ad0-0d41-49a6-9f0e-b5cc9aab2b0e',
	name: 'OneSignal',
	category: TEMPLATE_CATEGORIES.NOTIFICATIONS,
	popularity: 'Popular',
	color: '#e54b4d',
	icon: 'mdi-bell',
	description: 'Connect to OneSignal for cross-platform notifications.',
	features: ['API Key Auth', 'Push Notifications', 'Email Notifications', 'SMS'],
	configFields: [
		{ name: 'appId', label: 'App ID', type: 'text', required: true, placeholder: 'Enter your OneSignal App ID' },
		{ name: 'apiKey', label: 'REST API Key', type: 'password', required: true, placeholder: 'Enter your OneSignal REST API key' }
	],
	endpoints: [
		{
			name: 'Create User/Device',
			url: 'https://onesignal.com/api/v1/players',
			method: 'POST',
			description: 'Create or update a user/device in OneSignal',
			cassieObjectID: -3,
			incrementField: 'SyrenisID',
			resetincrementValue: false,
			fields: [
				{ name: 'SyrenisID', filter: '' },
				{ name: 'URN1', filter: '' },
				{ name: 'URN2', filter: '' },
				{ name: 'Email1', filter: '' }
			],
			requestBody: `{
			  "device_type": "[PLACEHOLDER_URN2:INT]",
			  "external_user_id": "[PLACEHOLDER_SYRENISID]",
			  "identifier": "[PLACEHOLDER_EMAIL1]"
			}`,
			headers: [
				{ Name: 'Authorization', value: 'Basic [API_KEY]' },
				{ Name: 'Content-Type', value: 'application/json' }
			],
			successResponses: [
				{ code: 200, message: '' }
			]
		},
		{
			name: 'Send Notification',
			url: 'https://onesignal.com/api/v1/notifications',
			method: 'POST',
			description: 'Send a notification to a user (used here to represent opt-in)',
			cassieObjectID: -3,
			incrementField: 'PreferenceID',
			resetIncrementValue: false,
			fields: [
				{ name: 'URN1', filter: '' },
				{ name: 'CHANNELID', filter: '' },
				{ name: 'SyrenisID', filter: '' }
			],
			requestBody: `{
				"app_id": "[APP_ID]",
				"include_external_user_ids": ["[PLACEHOLDER_SYRENISID]"],
				"contents": { "en": "[PLACEHOLDER_CHANNELID]" }
			}`,
			headers: [
				{ Name: 'Authorization', value: 'Basic [API_KEY]' },
				{ Name: 'Content-Type', value: 'application/json' }
			],
			successResponses: [
				{ code: 200, message: '' }
			]
		}

	],
	defaults: {
		endpointAddress: 'https://onesignal.com/api/v1',
		authenticationTypeId: AUTH_TYPES.API_KEY,
		frequencyInSeconds: 0,
		notes: 'OneSignal cross-platform notification service integration for push, email, and SMS messaging.'
	}
}
